module.exports = __webpack_public_path__ + "static/img/gr-1077-375bb.db31783.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2026/gr-1077-375bb.jpg
// module id = dIvd
// module chunks = 0